export default __webpack_public_path__ + "static/overlays-978288342d2b8c8899de548601209b0f.gif";